export default "__VITE_ASSET__EtVm7lmL__"